/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Diverse11Inputs */

const en__field_enum_tuda_diverse11 = /** @type {(inputs: _Field_Enum_Tuda_Diverse11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`diverse`)
};

const de__field_enum_tuda_diverse11 = /** @type {(inputs: _Field_Enum_Tuda_Diverse11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`divers`)
};

/**
* | output |
* | --- |
* | "diverse" |
*
* @param {_Field_Enum_Tuda_Diverse11Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_diverse11 = /** @type {((inputs?: _Field_Enum_Tuda_Diverse11Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Diverse11Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_diverse11(inputs)
	return de__field_enum_tuda_diverse11(inputs)
});
export { _field_enum_tuda_diverse11 as "_field_enum_TUDA_DIVERSE" }